import { ButtonWrapper } from "./styles"

export const SecondaryButton = (props) => {
    return (
        <ButtonWrapper onClick={props.onClick} $btnText={props.$btnText}>
            
        </ButtonWrapper>
    )
}